<template>
  <el-dialog
    :title="model.id ? `编辑采购单` : `添加采购单`"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <!-- <el-form-item label="订单号" prop="number">
        <el-input v-model="model.number"></el-input>
      </el-form-item> -->
      <el-form-item label="数据月份" prop="belong_month">
        <el-select
          class="long"
          v-model="model.belong_month"
          :disabled="model.id"
        >
          <el-option label="本月" :value="1" key="1"></el-option>
          <el-option label="上月" :value="2" key="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型" prop="business_type">
        <CommodityParamsSelect
          v-model="model.business_type"
          paramName="business_type"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="部门" prop="department">
        <CommodityParamsSelect
          v-model="model.department"
          paramName="department"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="业务员">
        <CommodityParamsSelect
          v-model="model.saler"
          paramName="saler"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="采购类型">
        <CommodityParamsSelect
          v-model="model.purchase_category"
          paramName="purchase_category"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="供货单位">
        <CommodityParamsSelect
          v-model="model.supplier"
          paramName="supplier"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="记账人">
        <CommodityParamsSelect
          v-model="model.bookkeeper"
          paramName="bookkeeper"
          table="purchase_orders"
        ></CommodityParamsSelect>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { purchaseOrderNew, purchaseOrderUpdate } from '@/service/getData'
import CommodityParamsSelect from './CommodityParamsSelect.vue'

export default {
  components: {
    CommodityParamsSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        number: [{ required: true, message: '请填写编号', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await purchaseOrderUpdate(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          } else {
            let res = await purchaseOrderNew(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>